/**
 * Catalogue de textes français pour la fonctionnalité commerce
 * (`@gamecodex/world-ui` → `features/commerce`).
 *
 * Les clés reflètent les appels `t('commerce.*')` dans les composants React de la fonctionnalité.
 * Les valeurs sont les chaînes françaises exactes extraites lors du balayage i18n.
 */
export const commerceFr = {
  // DtrpgClaimPage.tsx
  'commerce.dtrpg.seoTitle': 'Réclamez votre bibliothèque',
  'commerce.dtrpg.seoDescription': 'Importez votre bibliothèque DriveThruRPG et réclamez vos PDFs Grymwyrd.',
  'commerce.dtrpg.heading': 'Réclamez votre bibliothèque',
  'commerce.dtrpg.intro':
    'Avez-vous acheté Grymwyrd sur DriveThruRPG ou soutenu la campagne ? Connectez-vous avec votre email d\'achat pour importer votre bibliothèque et réclamez vos exemplaires.',
  'commerce.dtrpg.sendLinkError': 'Nous n\'avons pas pu envoyer votre lien de connexion pour l\'instant. Réessayez bientôt.',
  'commerce.dtrpg.checkInboxPrefix': 'Vérifiez votre boîte de réception à',
  'commerce.dtrpg.checkInboxSuffix':
    'Si cet email a acheté ou soutenu Grymwyrd, un lien de connexion est en route — cliquez-y pour revenir ici et réclamez votre bibliothèque.',
  'commerce.dtrpg.linkAutoSignIn': 'Le lien vous connecte automatiquement — aucun mot de passe nécessaire.',
  'commerce.dtrpg.purchaseEmailLabel': 'Votre email d\'achat ou de soutien',
  'commerce.dtrpg.sendingLink': 'Envoi du lien…',
  'commerce.dtrpg.emailLinkCta': 'Envoyez-moi un lien de connexion',
  'commerce.dtrpg.signedInAs': 'Connecté en tant que',
  'commerce.dtrpg.signOut': 'Se déconnecter',
  'commerce.dtrpg.dtrpgEmailLabel': 'Email DriveThruRPG',
  'commerce.dtrpg.dtrpgEmailOptional': '(optionnel — si différent de celui-ci)',
  'commerce.dtrpg.dtrpgEmailHelp': 'Nous l\'utilisons pour associer vos achats DriveThruRPG lors de l\'attribution de votre bibliothèque.',
  'commerce.dtrpg.libraryHeading': 'Votre bibliothèque Grymwyrd',
  'commerce.dtrpg.noTitles': 'Aucun titre importable n\'est encore configuré.',
  'commerce.dtrpg.claimNotInLibrary':
    'Ce titre n\'est pas encore dans votre bibliothèque. Assurez-vous d\'avoir utilisé le bon email d\'achat.',
  'commerce.dtrpg.claimSessionExpired': 'Votre session a expiré — connectez-vous de nouveau.',
  'commerce.dtrpg.claimError': 'Impossible de réclamez ce titre pour l\'instant. Veuillez réessayer.',
  'commerce.dtrpg.preparingCopy': 'Préparation de votre exemplaire…',
  'commerce.dtrpg.download': 'Télécharger',
  'commerce.dtrpg.preparing': 'Préparation…',
  'commerce.dtrpg.claiming': 'Réclamation…',
  'commerce.dtrpg.claim': 'Réclamer',

  // PaywallPrompt.tsx
  'commerce.paywall.checkoutFailed': 'Le paiement n\'a pas pu être ouvert. Veuillez réessayer bientôt.',
  'commerce.paywall.signInToPurchase': 'Connectez-vous pour compléter cet achat.',
  'commerce.paywall.vaultSealed': 'Le coffre du marchand est scellé pour l\'instant — veuillez réessayer bientôt.',
  'commerce.paywall.signInToUnlock': 'Se connecter pour déverrouiller',
  'commerce.paywall.comingSoonTitle': 'Cet achat sera bientôt disponible',
  'commerce.paywall.priceComingSoon': '{price} — bientôt disponible',
  'commerce.paywall.comingSoon': 'Bientôt disponible',
  'commerce.paywall.openingVault': 'Ouverture du coffre…',
  'commerce.paywall.unlockPrice': 'Déverrouiller — {price}',
  'commerce.paywall.unlock': 'Déverrouiller',

  // MarketplacePage.tsx
  'commerce.marketplace.installSuccess': '« {name} » installé sur votre table.',
  'commerce.marketplace.installNotOwned': 'Vous ne possédez pas encore ce pack — l\'achat de packs arrive bientôt.',
  'commerce.marketplace.installHostOnly': 'Seul l\'hôte de la table peut installer un pack.',
  'commerce.marketplace.installError': 'Impossible d\'installer ce pack. Veuillez réessayer.',
  'commerce.marketplace.installed': 'Installé',
  'commerce.marketplace.installing': 'Installation…',
  'commerce.marketplace.installOnTable': 'Installer sur la table',
  'commerce.marketplace.seoTitle': 'Marketplace — Packs',
  'commerce.marketplace.seoDescription':
    'Parcourez et installez des packs de contenu créateur — cartes, scènes, documents et présets — sur vos tables.',
  'commerce.marketplace.eyebrow': 'Marketplace',
  'commerce.marketplace.heading': 'Packs de contenu',
  'commerce.marketplace.intro':
    'Cartes, scènes, documents et présets de démarrage rapide — installez-les sur vos tables en un clic.',
  'commerce.marketplace.installingOnto': 'Installation sur la table {tableId}.',
  'commerce.marketplace.signInHeading': 'Connectez-vous pour voir vos packs',
  'commerce.marketplace.signInBlurb': 'Le catalogue de packs est lié à votre compte créateur.',
  'commerce.marketplace.signIn': 'Se connecter',
  'commerce.marketplace.loading': 'Invocation de vos packs…',
  'commerce.marketplace.noPacksHeading': 'Aucun pack pour l\'instant',
  'commerce.marketplace.noPacksBlurb':
    'Vous n\'avez pas encore publié de packs. Une marketplace publique pour parcourir les packs d\'autres créateurs arrive bientôt.',
  'commerce.marketplace.footer': 'Parcourir les packs d\'autres créateurs et les packs payants arrivent bientôt.',

  // SubscriberPerksPage.tsx
  'commerce.subscriber.perk1Title': 'Tables réservées aux abonnés',
  'commerce.subscriber.perk1Blurb': 'Prenez place aux tables que vos animateurs préférés réservent aux abonnés.',
  'commerce.subscriber.perk2Title': 'Contenu exclusif et précoce',
  'commerce.subscriber.perk2Blurb': 'Recevez les chapitres de campagne, les scènes et les documents avant tout le monde.',
  'commerce.subscriber.perk3Title': 'Insigne d\'abonné',
  'commerce.subscriber.perk3Blurb': 'Une marque de statut sur votre profil et à la table.',
  'commerce.subscriber.seoTitle': 'Avantages d\'abonné',
  'commerce.subscriber.seoDescription':
    'Devenez abonné pour des tables exclusives, du contenu précoce et votre insigne d\'abonné.',
  'commerce.subscriber.heading': 'Devenir abonné',
  'commerce.subscriber.intro':
    'Soutenez les animateurs et créateurs que vous aimez — et déverrouillez les avantages qu\'ils réservent à leur cercle intime.',
  'commerce.subscriber.activeHeading': 'Vous êtes abonné',
  'commerce.subscriber.activeBlurb':
    'Vos avantages sont actifs. Recherchez l\'écusson d\'abonné sur les tables que vous pouvez rejoindre.',
  'commerce.subscriber.findTable': 'Trouver une table d\'abonné',
  'commerce.subscriber.paywallTitle': 'Abonné Grymwyrd',
  'commerce.subscriber.paywallBlurb':
    'Déverrouillez les tables réservées aux abonnés, le contenu précoce et votre insigne d\'abonné.',
  'commerce.subscriber.paywallPrice': 'à partir de 5 $/mois',

  // TicketCheckoutPage.tsx
  'commerce.ticket.checkoutFailed': 'Le paiement n\'a pas pu être ouvert. Veuillez réessayer bientôt.',
  'commerce.ticket.signInToBuy': 'Connectez-vous pour acheter une place à cette table.',
  'commerce.ticket.boxOfficeClosed': 'Le guichet est fermé pour l\'instant — veuillez réessayer bientôt.',
  'commerce.ticket.seoTitle': 'Acheter une place',
  'commerce.ticket.seoDescription': 'Réservez votre place à une table avec billets.',
  'commerce.ticket.eyebrow': 'Table avec billets',
  'commerce.ticket.heading': 'Réservez votre place',
  'commerce.ticket.loading': 'Chargement de la table…',
  'commerce.ticket.notFoundHeading': 'Table introuvable',
  'commerce.ticket.notFoundBlurb': 'Cette table peut avoir fermé, ou ses portes n\'ont jamais été ouvertes.',
  'commerce.ticket.backToLobby': 'Retour au hall',
  'commerce.ticket.freeHeading': 'Cette table est gratuite',
  'commerce.ticket.freeBlurb': 'Aucun billet requis — tirez une chaise.',
  'commerce.ticket.goToLobby': 'Aller au hall',
  'commerce.ticket.untitledTable': 'Table sans titre',
  'commerce.ticket.seatPrice': 'Prix de la place',
  'commerce.ticket.spectatorsNote': 'Les spectateurs doivent également avoir un billet pour cette table.',
  'commerce.ticket.paymentReceived': 'Paiement reçu — votre place est réservée. Rendez-vous au hall pour la prendre.',
  'commerce.ticket.signInToBuySeat': 'Connectez-vous pour acheter une place',
  'commerce.ticket.openingBoxOffice': 'Ouverture du guichet…',
  'commerce.ticket.buySeatPrice': 'Acheter une place — {price}',
  'commerce.ticket.comingSoonTitle': 'Les billets arrivent bientôt',
  'commerce.ticket.ticketingComingSoon': 'Billets bientôt disponibles',
  'commerce.ticket.comingSoonFooter': 'Les places payantes sont presque prêtes. Pour l\'instant, demandez à l\'hôte une invitation gratuite.',

  // TipGoalManagerPage.tsx
  'commerce.tip.errHostOnlyGoal': 'Seul l\'hôte de la table peut gérer les objectifs.',
  'commerce.tip.errHostOnlyBounty': 'Seul l\'hôte de la table peut gérer les primes.',
  'commerce.tip.errMaxGoal': 'Vous avez atteint le nombre maximum d\'objectifs pour cette table.',
  'commerce.tip.errMaxBounty': 'Vous avez atteint le nombre maximum de primes pour cette table.',
  'commerce.tip.errMissingGoal': 'Cet objectif manque de détails requis.',
  'commerce.tip.errMissingBounty': 'Cette prime manque de détails requis.',
  'commerce.tip.errSignIn': 'Connectez-vous en tant qu\'hôte pour gérer cette table.',
  'commerce.tip.errSaveFailedGoal': 'Impossible d\'enregistrer l\'objectif. Veuillez réessayer.',
  'commerce.tip.errSaveFailedBounty': 'Impossible d\'enregistrer la prime. Veuillez réessayer.',
  'commerce.tip.goalValidation': 'Ajoutez une étiquette et un montant positif.',
  'commerce.tip.goalAdded': 'Objectif « {label} » ajouté.',
  'commerce.tip.goalLabelPlaceholder': 'Étiquette d\'objectif (ex. Invoquer le boss)',
  'commerce.tip.targetPlaceholder': 'Montant $',
  'commerce.tip.cuePlaceholder': 'Signal lors de l\'atteinte (ex. fanfare)',
  'commerce.tip.addGoal': 'Ajouter un objectif',
  'commerce.tip.bountyValidation': 'Ajoutez une étiquette, un montant positif et un déclencheur.',
  'commerce.tip.bountyAdded': 'Prime « {label} » ajoutée.',
  'commerce.tip.bountyLabelPlaceholder': 'Étiquette de prime (ex. Nat 20 sauve le groupe)',
  'commerce.tip.triggerPlaceholder': 'Déclencheur (ex. un 20 naturel)',
  'commerce.tip.addBounty': 'Ajouter une prime',
  'commerce.tip.signInToManage': 'Connectez-vous pour gérer cette table.',
  'commerce.tip.bountyClaimed': 'Prime « {label} » réclamée.',
  'commerce.tip.seoTitle': 'Objectifs de pourboire et primes',
  'commerce.tip.seoDescription': 'Définissez les objectifs de pourboire et les primes pour votre table.',
  'commerce.tip.backToLobby': 'Retour au hall',
  'commerce.tip.heading': 'Objectifs de pourboire et primes',
  'commerce.tip.intro':
    'Définissez les objectifs et les primes pour votre table. Quand le gobelet déborde, le signal se déclenche pour votre public. L\'affichage en direct est géré par votre superposition de retransmission.',
  'commerce.tip.loading': 'Lecture du journal…',
  'commerce.tip.loadErrorTitle': 'Impossible de charger le journal',
  'commerce.tip.raisedSoFar': 'Recueilli jusqu\'à présent :',
  'commerce.tip.tipGoalsHeading': 'Objectifs de pourboire',
  'commerce.tip.noGoals': 'Aucun objectif pour l\'instant — ajoutez le vôtre ci-dessous.',
  'commerce.tip.reachedAria': 'atteint',
  'commerce.tip.bountiesHeading': 'Primes',
  'commerce.tip.noBounties': 'Aucune prime pour l\'instant — ajoutez la vôtre ci-dessous.',
  'commerce.tip.whenLabel': '· quand : {trigger}',
  'commerce.tip.claimed': 'Réclamée',
  'commerce.tip.claimTitleReady': 'Marquer cette prime comme réclamée',
  'commerce.tip.claimTitleNotFunded': 'Pas encore financée',
  'commerce.tip.claim': 'Réclamer',
} as const
